import { CloudImage, ConfirmationDialog } from "@biom3/react";
import Image from "next/image";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { MODAL_WIDTH } from "@/constants";
import { useBraze } from "@/context";
import { analytics } from "@analytics";

const MarketingConsentModal = ({
  gameName,
  url,
  visible,
  closeModal,
}: {
  gameName?: string;
  url?: string;
  visible: boolean;
  closeModal: () => void;
}) => {
  const { t } = useTranslation();
  const { optIn } = useBraze();

  useEffect(() => {
    if (visible) {
      analytics.track(
        "PassportDashboardOnboardingMarketingConsent_OnboardingEffectRequest",
      );
    }
  }, [visible]);

  const onConfirm = () => {
    analytics.track(
      "PassportDashboardOnboardingMarketingConsent_ConfirmButtonPressed",
    );
    closeModal();
    optIn();
  };

  const onReject = () => {
    analytics.track(
      "PassportDashboardOnboardingMarketingConsent_RejectButtonPressed",
    );
    closeModal();
  };

  return (
    <ConfirmationDialog visible={visible}>
      <ConfirmationDialog.Content
        testId="MarketingConsentModal_Content"
        sx={{ width: MODAL_WIDTH }}
      >
        <ConfirmationDialog.Content.Image
          use={
            url ? (
              <CloudImage
                imageUrl={url}
                relativeImageSizeInLayout="430px"
                sx={{
                  alignSelf: "center",
                  width: "430px",
                  height: "287px",
                }}
                alt={gameName}
              />
            ) : (
              <Image
                src="/images/onboarding/hero.svg"
                width={430}
                height={287}
                alt=""
              />
            )
          }
        />
        <ConfirmationDialog.Content.Title>
          {t("marketing_consent_request", { gameName })}
        </ConfirmationDialog.Content.Title>
        <ConfirmationDialog.Content.Button
          size="large"
          testId="MarketingConsentModal_Confirm"
          onClick={onConfirm}
        >
          {t("marketing_consent_confirm")}
        </ConfirmationDialog.Content.Button>
        <ConfirmationDialog.Content.Button
          size="large"
          onClick={onReject}
          testId="MarketingConsentModal_Reject"
          variant="tertiary"
        >
          {t("marketing_consent_reject")}
        </ConfirmationDialog.Content.Button>
      </ConfirmationDialog.Content>
    </ConfirmationDialog>
  );
};

export { MarketingConsentModal };
